// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2HOr8","actionsCol":"EnrolledClinics_actionsCol__1VLBV"};